import { DsdEditorReviewDocument } from "./review-document";
import { Button } from "@/toggle-ui-kit/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DSD_EDITOR_COPY } from "./dsd-editor-copy";

const MissingDocumentIdView = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-background-neutral-normal">
      <header className="flex h-14 items-center gap-4 border-b border-line-normal bg-background-base px-6">
        <button
          type="button"
          onClick={() => navigate("/dsd-editor")}
          className="flex size-9 items-center justify-center rounded-small text-label-alternative transition-colors hover:bg-decorate-neutral/6 hover:text-label-normal"
          aria-label={DSD_EDITOR_COPY.view.backAriaLabel}
        >
          <ArrowLeft className="size-5" />
        </button>
        <h1 className="headline-1-medium text-label-normal">
          {DSD_EDITOR_COPY.view.fallbackTitle}
        </h1>
      </header>
      <main className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center">
        <p className="body-1-normal-regular text-label-alternative">
          {DSD_EDITOR_COPY.view.missingDocumentMessage}
        </p>
        <Button
          variant="outlined"
          color="secondary"
          size="base"
          onClick={() => navigate("/dsd-editor")}
        >
          {DSD_EDITOR_COPY.view.backToUpload}
        </Button>
      </main>
    </div>
  );
};

export const DsdReviewViewPage = () => {
  const [searchParams] = useSearchParams();
  const documentId = searchParams.get("document_id");
  const launchedFromEditor =
    searchParams.get("launched_from_editor") === "true";

  if (!documentId) return <MissingDocumentIdView />;

  return (
    <DsdEditorReviewDocument
      documentId={documentId}
      closeOnLoadError={launchedFromEditor}
    />
  );
};
